import { NgModule } from 'ng-metadata/core';
import { ToolbarComponent } from './toolbar.component';
import './toolbar.scss';

/**
 * @ngdoc module
 * @name mw.components.toolbar
 * @description
 *
 * Toolbar
 */
@NgModule({
  declarations: [ToolbarComponent]
})
export class ToolbarModule {}



// WEBPACK FOOTER //
// ./src/lib/components/toolbar/toolbar.module.ts